/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { AmiTableTemplate } from 'src/app/@amiga-pyme/templates/ami-table.template';

@Component({
  selector: 'ami-select',
  templateUrl: './ami-select.component.html'
})
export class AmiSelectComponent extends AmiTableTemplate {
  open = true;
  @Output() selectedRowsEvent = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges) {
    const settings = this.settings;
    this._selectedColumns = settings.columns;
    const currentData = changes?.data.currentValue;
    if (currentData) {
      this.listingData = false;
      this.data = currentData;
    }
  }

  onClose() {
    this.selectedRowsEvent.emit(null);
  }

  onRowSelect(event) {
    this.selectedRowsEvent.emit(event.data);
  }
}
